import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=f4d0246e&scoped=true"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"
import style0 from "./boards.vue?vue&type=style&index=0&id=f4d0246e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0246e",
  null
  
)

export default component.exports